exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-4d9d6674]{float:left;border:1px solid #fff;clear:both}", ""]);

// exports
